import { getAll, create } from '@/api/typeTaxationTlpe';
import store from '@/store/store';
import genererTypeTaxationTlpe from '@/services/parametrage/generation/genererTypeTaxationTlpe';

async function getTaxations(societeId) {
  return (await getAll({
    query: {
      societeId: societeId,
    },
  })).data.result.items;
}

export default async function getTypeTaxationTlpe(typeTaxationData) {
  const taxation = [...new Set(typeTaxationData)];
  const societeId = store.getters['societe/societeActiveId'];
  if (taxation.length === 0) return [];

  let result = getTaxations(societeId);

  let promiseAllTaxation = [];
  taxation.forEach((taxe) => {
    const isInApi = result.find((tlpe) => {
      return tlpe.libelle === taxe;
    });
    if (!isInApi) {
      const typeTaxationTlpe = genererTypeTaxationTlpe(societeId);
      typeTaxationTlpe.libelle = taxe;
      promiseAllTaxation.push(create(typeTaxationTlpe));
    }
  });

  if (promiseAllTaxation.length) {
    await Promise.all(promiseAllTaxation);
    promiseAllTaxation = [];
    result = getTaxations(societeId);
  }
  return result;
}
